<script setup lang="ts">
import { defineProps } from 'vue';
import useStickyAlerts from '@/modules/alerts/composables/useStickyAlerts';
import { StickyAlertPropsSchema } from '@/modules/alerts/models/sticky-alert-props';
import { STICKY_ALERT_TYPE } from '@/modules/alerts/models/sticky-alert-type';

const { findAlert, answerAlert } = useStickyAlerts();

const props = defineProps<StickyAlertPropsSchema>();

const alert = findAlert(STICKY_ALERT_TYPE.TEST, props.id);

const message = 'Test Alert';

const close = () => {
  answerAlert(alert, null);
};
</script>

<template>
  <div>
    <span style="background-color: fuchsia" @click="close">{{ message }}</span>
  </div>
</template>
